/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

export default function useZipCodeFields({
    form: {
        control,
        formState: {errors},
    },
    prefix = '',
}) {
    const {formatMessage} = useIntl()

    const fields = {
        code: {
            name: `${prefix}code`,
            label: formatMessage({
                defaultMessage: 'Zip Code',
                id: 'use_zip_code_zipcode.label.zip_code',
            }),
            type: 'text',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please provide a valid zip code.',
                    id: 'use_zip_code_fields.error.required_zip_code',
                }),
            },
            error: errors[`${prefix}code`],
            control,
            dataCsMask: true,
        },
    }

    return fields
}
